// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__Ya3Zn","title":"FrontImage_title__3SBbc"};